/* eslint-disable import/prefer-default-export */
/**
 * A place for us to keep shared actions.
 * If you have an action that you want picked up by two slices put it here
 * This will allow us to lazy load dependent slices
 */

export const SUBMIT_DETAILS_SUCCESS = 'profile/SUBMIT_DETAILS_SUCCESS';
